<script>
  export default {
    name: 'help-resolution-buttons',
    data() {
      return { answer: '' }
    },
  }
</script>
